import { buildEqFilter } from '@/ui/composites/grid/gridFilters';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { TestListItemDto } from '@flowqa/shared';

export const resolveTestRunChildCount = (
  row: Pick<TestListItemDto, 'executionStatusCounts' | 'executionSummaries'>,
): number => row.executionStatusCounts?.total ?? row.executionSummaries?.length ?? 0;

export const buildNestedTestRunFilters = ({
  latestOnly,
  latestRunId,
  testId,
}: {
  latestOnly: boolean;
  latestRunId: string | null;
  testId: string;
}): GridQueryInput['filters'] =>
  latestOnly && latestRunId !== null
    ? buildEqFilter('id', latestRunId)
    : buildEqFilter('testId', testId);
